import { abbreviatePrefixObj } from 'stardog-language-utils';

export const getAbbreviationOrFullIri = (
  iri: string,
  namespaces: Record<string, string>
) => {
  const abbreviated = abbreviatePrefixObj(iri, namespaces);
  return abbreviated === iri ? `<${iri}>` : abbreviated;
};
